import type { Team } from './types.js';

export const TEAMS: readonly Team[] = ['I', 'B'];

export function otherTeam(team: Team): Team {
  return team === 'I' ? 'B' : 'I';
}

export const TEAM_NAMES: Readonly<Record<Team, string>> = { I: 'Ivory', B: 'Basalt' };
